import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AvanceProcesalDto } from '../dto/avance-procesal/avance-procesal.dto';

@Injectable({
  providedIn: 'root',
})
export class AvanceProcesalService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/avance-procesal';

  constructor(private http: HttpClient) {}

  postCrearAvanceProcesal(
    expedienteId: number,
    data: FormData
  ): Observable<AvanceProcesalDto> {
    return this.http.post<AvanceProcesalDto>(
      `${this.apiUrl}${this.baseUrl}/${expedienteId}`,
      data
    );
  }

  getAvanceProcesalByUserAndExpediente(
    expedienteId: number
  ): Observable<AvanceProcesalDto[]> {
    return this.http.get<AvanceProcesalDto[]>(
      `${this.apiUrl}${this.baseUrl}/${expedienteId}`
    );
  }
}
